import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { DEFAULT_FILTER } from '../admin/user';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../consts/table';
import { Count } from '../../../models/count';

export interface AwardItem {
  id: string;
  awardType: { id: string; name: string; picture?: string };
  awardedAt: string;
  awardedByName?: string;
  houseId?: string | null;
  houseName?: string | null;
  reason?: string;
  points: number;
  house?: { id: string; name: string | null; pic?: string | null } | null;
  school?: { id: string; pic?: string | null } | null;
  student?: {
    id: string;
    firstName: string;
    lastName: string;
    displayName: string;
  } | null;
}

export interface ParentAwardsOverview {
  items: AwardItem[];
  total: number;
  points: number;
  awardedChildren: number;
  children: any[];
}

export function getChildrenAwardsCurrentOverview(user: AppUser, filter): Promise<ParentAwardsOverview> {
  const { roleSessionKey: key } = user;
  return axios
    .get<ParentAwardsOverview>(`${window.apiBase}/i/children/awards/current/overview`, {
      headers: { usid: key },
      params: { filter }
    })
    .then(response => response.data);
}

export function getChildrenAwardsCurrent(user: AppUser, filter) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: filter
    }
  };
  return axios.get(`${window.apiBase}/i/children/awards/current`, config).then(response => {
    return response.data;
  });
}

export function getChildrenAwardsCurrentCount(user: AppUser, where?): Promise<Count> {
  const { roleSessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          }
        }
      }
    };
  } else {
    config = {
      headers: { usid: key }
    };
  }

  return axios.get<Count>(`${window.apiBase}/i/children/awards/current/count`, config).then(response => {
    return response.data;
  });
}
